/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// Base des routes Hubee. Centralisée ici car elle est utilisée par la liste,
// la fiche demande et l'assistant : si le back expose les télédossiers PACS
// ailleurs, il n'y a que cette constante à changer.
export const baseUrlApiHubee = '/api/administres/etat-civil/hubee/teledossiers';

export const getHubeeTeledossiers = () => baseUrlApiHubee;

export const getHubeeTeledossier = (identifiant: string | number) =>
  `${baseUrlApiHubee}/${identifiant}`;

/** Marque le télédossier comme traité une fois le PACS créé */
export const getHubeeTraiterTeledossier = (identifiant: string | number) =>
  `${baseUrlApiHubee}/${identifiant}/traiter`;

/** Contenu binaire d'une pièce jointe (streaming, sans base64) */
export const getHubeeDocumentContenu = (
  identifiant: string | number,
  identifiantPieceJointe: string | number,
) =>
  `${baseUrlApiHubee}/${identifiant}/documents/${identifiantPieceJointe}/contenu`;

const baseUrlApiHubeeLiaison = '/api/administres/etat-civil/hubee';

/** Paramétrage HubEE de l'entité (GET lecture, PUT enregistrement) */
export const getHubeeParametrage = () =>
  `${baseUrlApiHubeeLiaison}/parametrage`;

/** Test d'authentification auprès de HubEE avec le paramétrage enregistré */
export const getHubeePing = () => `${baseUrlApiHubeeLiaison}/ping`;

/** Abonnement (serial) et liaison active */
export const getHubeeStatus = () => `${baseUrlApiHubeeLiaison}/status`;
